const cryptocurrency = {
  paymentMethodName: 'Cryptocurrency',
  cryptocurrencyLabel: 'Cryptocurrency',
  cryptocurrencySelectPlaceholder: 'Select your cryptocurrency',
  protocolWarning: 'If the payment is made using a different network than selected, the funds may be permanently lost. Please <b>make sure your wallet is configured for the correct network</b> before proceeding.',
  networkLabel: 'Network',
  networkSelectPlaceholder: 'Select your network',
  paymentButtonLabel: 'Pay with Cryptocurrency',
  amountLocal: 'Local amount',
  amountCrypto: 'Crypto amount',
  paymentCreatedTitle: 'Your payment has been created!',
  paymentCreatedSubtitle: 'It won’t take long for your order to be completed! Follow the instructions below to confirm this transaction.',
  qrCodeInstruction: 'Scan the following QR code in your wallet to complete the payment in just a few seconds',
  qrCodeNetworkNotFound: 'Network not found. Please make sure you have selected the correct network.',
  networkWarning: 'You are paying <b>{cryptocurrency}</b> using <b>{protocol}</b>. Make sure to select the correct network in your wallet, otherwise your funds may be lost.',
  conversionRate: 'The converted value is 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}. This value is calculated in real time and may fluctuate based on the exchange rate.',
  paymentApproved: 'Your payment of <AmountText>{amountLocal}</AmountText> has been approved.',
  howToPayInfoTitle: 'How to pay with Crypto?',
  howToPayOpenApp: 'Open your wallet (app or extension) and tap on the option Buy, Transfer, Send, or Pay.',
  howToPayQrCode: 'Scan the QR code and fill in the required fields using copy and paste.',
  howToPayNetwork: 'Make sure you select the correct network. If the wrong one is chosen, the funds may not be recoverable.',
  howToPayConfirmation: 'Track the status in your wallet (Activity/History) or return to this page to wait for confirmation.',
  payAgreement1: 'By continuing, you agree to the EBANX\'s ',
  serviceTerms: 'Terms and Conditions',
  payAgreement2: '.',

};

module.exports = cryptocurrency;
